import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import logger from "../../../../../../utils/LoggerFrontend";

import { channelsByShortName } from "../../../../../../data/app__channels";
import * as SC from "./PrintPostEditorSpotify.styled.js";

import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";
import PrintCampaignCreatePhotoEditor from "../../print-campaign-create-photo-editor/PrintCampaignCreatePhotoEditor";
import MusicPlayer from "../../../../Previews/MusicPlayer/MusicPlayer";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor.jsx";

const PrintPostEditorSpotify = ({
  orgaId,
  postData,
  channel,
  channelData,
  editable,
  selectedCreativeIndexToEdit,
  mediaAssetsProps,
  mediaAssets
}) => {
  const { t } = useTranslation();

  const [musicData, setMusicData] = useState({});

  useEffect(() => {
    if (postData?.audioData) {
      setMusicData(postData.audioData);
    }
  }, [postData]);

  logger.debug("PostEditorSpotify:render", "render:", {
    postData,
    channelData,
    editable,
    musicData
  });

  const templatePreviewSizes = {
    minHeight: SC.SPOTIFY_IMAGE_SIZE_SPEC.minHeight,
    maxHeight: SC.SPOTIFY_IMAGE_SIZE_SPEC.maxHeight,
    width: SC.SPOTIFY_IMAGE_SIZE_SPEC.pictureWidth,
    minAspect: channelsByShortName.spotify.minAspect,
    maxAspect: channelsByShortName.spotify.maxAspect
  };

  return (
    <SC.PostEditorSpotifyWrapper>
      <SC.MobileHead>9:41</SC.MobileHead>
      <SC.Header>
        <SC.Ad>Ad</SC.Ad>
        <SC.ChannelDataHeaderWrapper>
          <PrintCampaignCreateChannelDataEditor
            value={channelData.companyName}
            dataKey="companyName"
            textStyle={SC.companyNameStyle}
            limit={channelsByShortName.spotify.limits.companyName}
            label="Firmenname"
            tooltip="Firmenname"
            editable={false}
            padding="3px 1px 3px 6px"
            dark
          />
          :
          <PrintCampaignCreateChannelDataEditor
            value={channelData.title}
            dataKey="title"
            textStyle={SC.titleStyle}
            limit={channelsByShortName.spotify.limits.title}
            label={t("Job Title")}
            editable={false}
            padding="3px 6px 3px 3px"
            dark
          />
        </SC.ChannelDataHeaderWrapper>
      </SC.Header>
      <PrintTemplateEditor
        mediaAssets={mediaAssets}
        mediaAssetsProps={mediaAssetsProps}
        selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
        templatePreviewSizes={templatePreviewSizes}
        channel={channel}
      />
      <SC.PhotoWrapper>
        <SC.PageLogoWrapper>
          <PrintCampaignCreatePhotoEditor
            orgaId={orgaId}
            postDataKey="logos"
            creatives={postData?.logos || []}
            selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
            minHeight={50}
            maxHeight={50}
            minAspect={1}
            maxAspect={1}
            width={50}
            borderRadius="100%"
            editable={editable}
            isLogo={true}
          />
        </SC.PageLogoWrapper>
        <SC.ApplyButton target="_blank" href={channelData.url}>
          {t("Apply now")}
        </SC.ApplyButton>
      </SC.PhotoWrapper>
      <MusicPlayer
        postData={musicData}
        channel={channelData.channel}
        isAutoGenerated={postData?.isAutoGenerated}
        autoGeneratedText={postData?.autoGeneratedText}
        isAutoGenerationStreaming={postData?.isAutoGenerationStreaming}
      />
    </SC.PostEditorSpotifyWrapper>
  );
};

export default PrintPostEditorSpotify;
